import uuid from 'react-uuid';

export const generateKey = (): {key: string} => ({ key: uuid() });
